import {useState} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';



import SearchIcon from '@mui/icons-material/Search';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

import ShipmentsFilterCustomerLookup from './ShipmentsFilterCustomerLookup';
import ShipmentsFilterShipDateOperatorList from './ShipmentsFilterShipDateOperatorList';
import ShipmentsFilterProductLookup from './ShipmentsFilterProductLookup';
import ShipmentsFilterReelTypeLookup from './ShipmentsFilterReelTypeLookup';
import ShipmentsFilterStatus from './ShipmentsFilterStatusList';

import { useSessionContext } from '../../../contexts/SessionContext';


export default function ShipmentsFilter(props) {
    //console.debug("RTS Break ShipmentsFilter");

    const {user} = useSessionContext();

    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [showReelTypeModal, setShowReelTypeModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);

    const [customer, setCustomer] = useState(props.filter===null?null:props.filter.customer);
    const [shipDateOperator, setShipDateOperator] = useState(">=");
    const [shipDate, setShipDate] = useState(props.filter==null?null:props.filter.shipDate);
    const [product, setProduct] = useState(props.filter===null?null:props.filter.product);
    const [reelType, setReelType] = useState(props.filter===null?null:props.filter.reelType);
    const [salesOrder, setSalesOrder] = useState(props.filter===null?null:props.filter.salesOrder);
    const [customerPO, setCustomerPO] = useState(props.filter===null?null:props.filter.customerPO);
    const [deliveryNumber, setDeliveryNumber] = useState(props.filter===null?null:props.filter.deliveryNumber);
    const [reelSerialNumber, setReelSerialNumber] = useState(props.filter===null?null:props.filter.reelSerialNumber);
    const [returnDate, setReturnDate] = useState(props.filter===null?null:props.filter.returnDate);
    const [status, setStatus] = useState(props.filter===null?1:props.filter.status);

    const [showFilter, setShowFilter] = useState(true);


    function setParentFilter(e){
        let args = {"user":user,
                    "customer":customer==null?null:customer,
                    "shipDate":shipDate==null?null:shipDate,
                    "product":product==null?null:product, 
                    "reelType":reelType==null?null:reelType,
                    "salesOrder":salesOrder==null?null:salesOrder,
                    "customerPO":customerPO==null?null:customerPO,
                    "deliveryNumber":deliveryNumber==null?null:deliveryNumber,
                    "reelSerialNumber":reelSerialNumber==null?null:reelSerialNumber,
                    "returnDate":returnDate==null?null:returnDate,
                    "status":status 
                    }
        props.setFilterFx(args);
    }


    function toggleShowFilter()
    {
        setShowFilter(!showFilter);
    }


    function setCustomerVal(pValue){
        setCustomer(pValue);
        setShowCustomerModal(false);
    };


    function clearCustomer(){
        setCustomer(null);
        setShowCustomerModal(false);
    }        


    function setProductVal(pValue){
        setProduct(pValue);
        setShowProductModal(false);
    };
    
    
    function clearProduct(){
        setProduct(null);
        setShowProductModal(false);
    }   

    
    function setReelTypeVal(pValue){
        setReelType(pValue);
        setShowReelTypeModal(false);
    };

    function setStatusVal(pValue){
        setStatus(pValue);
    }


    function clearReelType(){
        setReelType(null);
        setShowReelTypeModal(false);
    }    



    return (
        <>
        <Dialog fullWidth={true} maxWidth="md" open={showCustomerModal} onClose={()=>{setShowCustomerModal(false);}}>
            <DialogTitle>Customer</DialogTitle>
            <DialogContent>
                <Box>
                    <ShipmentsFilterCustomerLookup customer={customer} setValueFx={setCustomerVal} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowCustomerModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="md" open={showProductModal} onClose={()=>{setShowProductModal(false);}}>
            <DialogTitle>Product</DialogTitle>
            <DialogContent>
                <Box>
                    <ShipmentsFilterProductLookup product={product} setProductValFx={setProductVal} clearValueFx={clearProduct} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowProductModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog>         
        <Dialog open={showReelTypeModal} fullWidth={true} maxWidth="md" onClose={()=>{setShowReelTypeModal(false);}}>
            <DialogTitle>Select Reel Type</DialogTitle>
            <DialogContent>
                <ShipmentsFilterReelTypeLookup data={reelType} setReelTypesFx={setReelTypeVal} clearValueFx={clearReelType} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowReelTypeModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog> 
        <Box sx={{pt:1}}>
            <Box sx={{visibility:showFilter===true?"visible":"hidden", display:showFilter===true?"initial":"none"}}>
                <Grid container id="gridContainer">
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, mt:1}}>
                        <Box id="Customer" sx={{display:'flex', alignItems:'center'}}>
                            <TextField
                                id="tbCustomer"
                                margin="small"
                                fullWidth
                                label="Customer"
                                size="small"
                                value={customer==null?'':customer.name + " (" + customer.idSap + ")"}
                                onClick={setShowCustomerModal}
                            />
                            <Box sx={{ml:1}}>            
                                <Button variant="contained" onClick={setShowCustomerModal}>
                                    <SearchIcon sx={{fontSize:'2em'}} />
                                </Button>
                            </Box>            
                        </Box> 
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Box sx={{display:'flex'}}>
                            <ShipmentsFilterShipDateOperatorList shipDateOperator={shipDateOperator} setShipDateOperatorFx={setShipDateOperator} />
                            <DatePicker
                                id="tbShipDate"
                                label="Ship Date"
                                inputFormat="MM/dd/yyyy"
                                value={shipDate}
                                onChange={setShipDate}
                                slotProps={{ field: { clearable: true }, textField:{size:'small'} }}
                            />   
                        </Box>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, mt:1}}>
                        <Box id="Product" sx={{display:'flex', alignItems:'center'}}>
                            <TextField
                                id="tbProduct"
                                margin="small"
                                fullWidth
                                label="Product"
                                size="small"
                                value={product==null?'':product.name + " (" + product.idSap + ")"}
                                onClick={setShowProductModal}
                            />
                            <Box sx={{ml:1}}>            
                                <Button variant="contained" onClick={setShowProductModal}>
                                    <SearchIcon sx={{fontSize:'2em'}} />
                                </Button>
                            </Box>            
                        </Box> 
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, mt:1}}>
                        <Box id="ReelType" sx={{display:'flex', alignItems:'center', width:'100%'}}>
                            <TextField
                                id="tbReelType"
                                margin="small"
                                fullWidth
                                label="ReelType"
                                size="small"
                                value={reelType==null?'':reelType.name}
                                onClick={setShowReelTypeModal}
                            />
                            <Box sx={{ml:1}}>            
                                <Button variant="contained" onClick={setShowReelTypeModal}>
                                    <SearchIcon sx={{fontSize:'2em'}} />
                                </Button>
                            </Box>            
                        </Box>  
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3} sx={{textAlign:{xs:'center',sm:'left'}, px:1, mt:1}}>
                        <ShipmentsFilterStatus status={status} setStatusFx={setStatusVal} />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <TextField
                            id="tbSalesOrder"
                            margin="none"
                            fullWidth
                            label="SAP Sales Order"
                            size="small"
                            value={salesOrder}
                            onChange={(e) => {setSalesOrder(e.target.value);}}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <TextField
                            id="tbCustomerPO"
                            margin="none"
                            fullWidth
                            label="Customer Purchase Order"
                            size="small"
                            value={customerPO}
                            onChange={(e) => {setCustomerPO(e.target.value);}}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <TextField
                            id="tbDeliveryNumber"
                            margin="none"
                            fullWidth
                            label="SAP Delivery Number"
                            size="small"
                            value={deliveryNumber}
                            onChange={(e) => {setDeliveryNumber(e.target.value);}}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <TextField
                            id="tbReelSerialNumber"
                            margin="none"
                            fullWidth
                            label="Reel Serial Number"
                            size="small"
                            value={reelSerialNumber}
                            onChange={(e) => {setReelSerialNumber(e.target.value);}}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3} sx={{px:1, pt:1}}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Box sx={{display:'flex'}}>
                            <DatePicker
                                id="tbReturnDate"
                                label="Return Date"
                                inputFormat="MM/dd/yyyy"
                                value={returnDate}
                                onChange={setReturnDate}
                                slotProps={{ field: { clearable: true }, textField:{size:'small'} }}
                            />   
                        </Box>
                        </LocalizationProvider>
                    </Grid>                    

                    <Grid item xs={12} sx={{px:1, pt:1}}>
                        <Grid container>
                            <Grid item xs={12} sm={6} lg={6} sx={{textAlign:{xs:'center', sm:'left'}}}>
                                <Button type="button" variant="contained" onClick={setParentFilter} sx={{mt:1}} >
                                    <SearchIcon />
                                    <Typography sx={{ml:1}}>Find</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>                        
                </Grid>
                <Box onClick={toggleShowFilter}>
                    <Button variant="text" startIcon={<ArrowCircleUpOutlinedIcon />} size="small">Hide Filters</Button>
                </Box>                
            </Box>
            <Box sx={{visibility: showFilter===true?"hidden":"visible", display:showFilter===true?"none":"initial"}}>
                <Box onClick={toggleShowFilter}>
                    <Button variant="text" startIcon={<ArrowCircleDownIcon />} size="small">Show Filters</Button>
                </Box>
            </Box>                     
        </Box>
        </>
    );
}
